import { Editor } from 'slate'

export const withFileAttachment = (editor: Editor): Editor => {
  const { isVoid } = editor

  editor.isVoid = node => node.type === 'file-attachment' || isVoid(node)

  return editor
}
